export const maskPhoneNumber = (phone) => {
  return phone.replace(phone.substr(-4, 3), "***");
};
